import { Injectable } from '@angular/core';
import {
  App,
  AppKey,
  AppSettings,
  GetMultiAppRequest,
  GetMultiAppResponse,
  ListAppSettingsRequest,
  ListAppSettingsResponse,
  PartnerApiService,
} from '@galaxy/marketplace-apps';
import { Observable } from 'rxjs';
import { map, share, shareReplay } from 'rxjs/operators';
import { partnerId } from '../../globals';

@Injectable({ providedIn: 'root' })
export class AppPartnerService {
  constructor(private partnerApiService: PartnerApiService) {}

  public getMulti(appKeys: AppKey[], marketId: string): Observable<App[]> {
    return this.partnerApiService
      .getMultiApp(
        new GetMultiAppRequest({
          appKeys: appKeys,
          projectionFilter: null,
          partnerId,
          marketId: marketId,
        }),
      )
      .pipe(
        map((resp: GetMultiAppResponse) => {
          return (resp || { apps: [] }).apps || [];
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
      );
  }

  public listAppSettings(
    partnerId: string,
    marketId: string,
    cursor: string,
    pageSize: number,
  ): Observable<AppSettings[]> {
    if (!pageSize) {
      pageSize = 1000;
    }
    const req = new ListAppSettingsRequest({
      partnerId: partnerId,
      marketId: marketId,
      cursor: cursor,
      pageSize: pageSize,
    });
    return this.partnerApiService.listAppSettings(req).pipe(
      map((resp: ListAppSettingsResponse) => {
        if (resp.hasMore) {
          console.log('Reached page limit');
        }
        return resp ? resp.appSettings : [];
      }),
      share(),
    );
  }
}
